import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import RFQTabs from "../../components/SellerDashboard/Requirements/RFQTabs";
import RFQTable from "../../components/SellerDashboard/Requirements/RFQTable";
import SearchBar from "../../components/Common/SearchBar";
import Pagination from "../../components/Common/Pagination";
import { useRFQData } from "../../components/SellerDashboard/Requirements/useRFQData";
import { useCompanyData } from "../../hooks/useCompanyData";

export default function SellerRequirement() {
  const location = useLocation();
  const hasSetInitialTab = useRef(false);
  const [search, setSearch] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState("new");
  const { company: companyData } = useCompanyData();
  const isCompanyApproved = companyData?.status === 'Approved';

  // Fetch requirements for active tab + counts for all tabs
  const { loading, requirements, counts, totalResults, totalPages, formatDate, findTabConfig, getActiveMainTab, editRequirementData } =
    useRFQData(activeTab, search, currentPage, perPage);

  // Handle navigation state to set initial tab (only once)
  useEffect(() => {
    if (location.state?.activeTab && !hasSetInitialTab.current) {
      console.log("Navigated with activeTab:", location.state.activeTab);
      setActiveTab(location.state.activeTab);
      hasSetInitialTab.current = true;
      // Reset currentPage when tab changes from navigation
      setCurrentPage(1);
    }
  }, []);

  if (!isCompanyApproved && !loading) return 'Your Details are not Approved Yet. We are Working on its approval.'

  return (
    <div className="container mt-4 border rounded p-3 buyer-table">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <h5 className="fw-bold">Requirements</h5>
        <SearchBar
          search={search}
          setSearch={setSearch}
          setCurrentPage={setCurrentPage}
        />
      </div>

      {/* Tabs */}
      <RFQTabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        counts={counts}
        setCurrentPage={setCurrentPage}
        getActiveMainTab={getActiveMainTab}
      />

      {/* Table */}
      <RFQTable
        loading={loading}
        currentData={requirements}
        formatDate={formatDate}
        findTabConfig={findTabConfig}
        activeTab={activeTab}
        editRequirementData={editRequirementData}
      />

      {/* Pagination */}
      <Pagination
        perPage={perPage}
        setPerPage={setPerPage}
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        totalPages={totalPages}
        totalResults={totalResults}
      />

      {/* Scoped styles */}
      <style>{`
        .buyer-table table {
          border-radius: 12px;
          border: 1px solid #e5e7eb;
          overflow: hidden;
        }
        .buyer-table thead th {
          background-color: #f9fafb;
          font-weight: 600;
          color: #4B5675;
        }
        .buyer-table tbody tr:hover {
          background-color: #f9fafb;
        }
        .tab-item {
          transition: color 0.3s ease;
        }
        .tab-underline {
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background-color: black;
          transition: all 0.3s ease;
        }
      `}</style>
    </div>
  );
}
